<template>
  <div>
    <van-nav-bar title="绑定支付宝" left-arrow @click-left="$router.go(-1)" />
    <van-cell-group>
      <van-field v-model="account" required clearable label="支付宝账号" placeholder="请输入支付宝账号" />
      <van-field v-model="name" label="真实姓名" placeholder="请输入真实姓名" required />
      <van-button type="danger" size="large" @click="addAlipay()">保存</van-button>
    </van-cell-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      account: "",
      name: ""
    };
  },
  created() {
    this.Post({}, "/main/AlipayInfo", res => {
      if (res.states == 1) {
        if (res.data !== null) {
          const data = res.data.alipay;
          this.account = data.ali_account;
          this.name = data.real_name;
        }
      } else {
        this.Toast.fail(res.msg);
      }
    });
  },
  methods: {
    // 添加支付宝信息
    addAlipay() {
      this.Post(
        {
          account: this.account,
          name: this.name
        },
        "/main/addAlipay",
        res => {
          if (res.states == 1) {
            this.Toast.success("保存成功");
            if (this.$route.query.goBack == 1) {
              setTimeout(() => {
                this.$router.go(-1);
              }, 1000);
            }
          } else {
            this.Toast.fail(res.msg);
          }
        }
      );
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/mine/alipay.vue